/*
 * ETOLIE — logika kafelka produktu (ulubione, swatche koloru, galeria kafelka,
 * dodanie do koszyka z listingu). Jeden plik dla home, kolekcji, wyszukiwarki,
 * Ulubionych i rekomendacji na karcie produktu.
 *
 * 03.09.2026 (ETAP 7, krok 7c): kod wyszedł z inline <script> w
 * snippets/etolie-cards-assets.liquid (39,8 kB w KAŻDYM dokumencie HTML i w każdej
 * odpowiedzi Section Rendering) do tego pliku. Ładuje go raz snippets/etolie-luxury.liquid
 * jako klasyczny skrypt z defer — obok assets/etolie-card.css, które przeszło tą samą
 * drogę w ETAPIE 4. Zero tagów Liquid, więc plik jest w pełni cache'owalny.
 *
 * Kontrakt zewnętrzny (bez zmian): window.etolieFavs, window.etolieMarkFavButtons,
 * window.etolieInitCards(root), window.etolieDestroyCards(root), zdarzenie 'etolie:favs'.
 * Nowo wstawione kafelki (doładowanie home, filtry, rekomendacje) inicjalizuje
 * wywołanie window.etolieInitCards(kontener) po stronie tego, kto je wstawił.
 */

if (!window.__etolieCards) {
  window.__etolieCards = true;

  // Ulubione są własnością produktu + koloru. ID wariantu zostaje wyłącznie
  // payloadem linku, więc zmiana rozmiaru nie tworzy drugiego ulubionego.
  // Stary format ["handle"] pozostaje wpisem obejmującym cały produkt.
  function normalizeFavItem(raw) {
    if (typeof raw === 'string') {
      const handle = raw.trim();
      return handle ? { handle: handle, variantId: '', color: '' } : null;
    }
    if (!raw || typeof raw !== 'object') return null;
    const handle = String(raw.handle || raw.h || '').trim();
    if (!handle) return null;
    return {
      handle,
      variantId: String(raw.variantId || raw.variant_id || raw.v || '').trim(),
      color: String(raw.color || raw.c || '').trim(),
    };
  }

  function favHandleKey(raw) {
    const item = normalizeFavItem(raw);
    return item ? item.handle.toLocaleLowerCase('pl-PL') : '';
  }

  function favColorKey(value) {
    return String(value || '')
      .trim()
      .toLocaleLowerCase('pl-PL')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  }

  function favItemKey(raw) {
    const item = normalizeFavItem(raw);
    if (!item) return '';
    const color = favColorKey(item.color);
    return favHandleKey(item) + '::' + (color ? 'color:' + color : 'product');
  }

  function compactFavItems(rawItems) {
    const normalized = (Array.isArray(rawItems) ? rawItems : [])
      .map(normalizeFavItem)
      .filter(Boolean);
    const productLevelHandles = new Set(
      normalized.filter((item) => !favColorKey(item.color)).map(favHandleKey)
    );
    const seen = new Set();

    return normalized.reduce((items, item) => {
      const handle = favHandleKey(item);
      const isProductLevel = !favColorKey(item.color);
      if (productLevelHandles.has(handle) && !isProductLevel) return items;

      const key = favItemKey(item);
      if (!key || seen.has(key)) return items;
      seen.add(key);
      items.push(item);
      return items;
    }, []);
  }

  window.etolieFavs = {
    normalize: normalizeFavItem,
    handleKey: favHandleKey,
    colorKey: favColorKey,
    key: favItemKey,
    get() {
      let stored = [];
      try {
        const parsed = JSON.parse(localStorage.getItem('etolie_favs') || '[]');
        stored = Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
      const clean = compactFavItems(stored);
      if (JSON.stringify(stored) !== JSON.stringify(clean)) {
        try {
          localStorage.setItem('etolie_favs', JSON.stringify(clean));
        } catch (e) {
          // Odczyt nadal działa, nawet gdy przeglądarka blokuje zapis migracji.
        }
      }
      return clean;
    },
    set(list, detail) {
      const clean = compactFavItems(list);
      try {
        localStorage.setItem('etolie_favs', JSON.stringify(clean));
      } catch (e) {
        return false;
      }
      document.dispatchEvent(new CustomEvent('etolie:favs', {
        detail: Object.assign({ count: clean.length }, detail || {}),
      }));
      return true;
    },
    toggle(raw, options) {
      const item = normalizeFavItem(raw);
      if (!item) return false;
      const list = this.get();
      const key = favItemKey(item);
      let index = list.findIndex((saved) => favItemKey(saved) === key);
      let added = false;

      // Stary wpis po samym handle reprezentuje cały produkt. Kliknięcie
      // zaznaczonego serca dowolnego koloru usuwa ten wpis bez tworzenia dubla.
      if (index < 0 && options && options.matchLegacy) {
        index = list.findIndex(
          (saved) => favHandleKey(saved) === favHandleKey(item) && !favColorKey(saved.color)
        );
      }
      if (index >= 0) list.splice(index, 1);
      else {
        list.push(item);
        added = true;
      }
      this.set(list);
      return added;
    },
  };

  function favItemFromButton(button) {
    return normalizeFavItem({
      handle: button && button.dataset.etolieFav,
      variantId: button && button.dataset.etolieFavVariant,
      color: button && button.dataset.etolieFavColor,
    });
  }

  function markFavButtons(root) {
    const list = window.etolieFavs.get();
    const exact = new Set(list.map(favItemKey));
    const productLevel = new Set(
      list.filter((item) => !favColorKey(item.color)).map(favHandleKey)
    );
    (root || document).querySelectorAll('[data-etolie-fav]').forEach((button) => {
      const item = favItemFromButton(button);
      const on = !!(
        item
        && (exact.has(favItemKey(item)) || productLevel.has(favHandleKey(item)))
      );
      button.classList.toggle('is-fav', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      const labelBase = button.dataset.etolieFavLabel || (item && item.handle) || window.etolieT("produkt");
      const displayColor = button.dataset.etolieFavDisplayColor || (item && item.color) || '';
      const label = labelBase + (displayColor ? ', ' + displayColor : '');
      button.setAttribute('aria-label', (on ? window.etolieT('Usuń z ulubionych') : window.etolieT('Zapisz w ulubionych')) + ': ' + label);
      const text = button.querySelector('[data-etolie-fav-text]');
      if (text) text.textContent = on ? window.etolieT("W ulubionych") : window.etolieT("Dodaj do ulubionych");
    });
  }
  window.etolieMarkFavButtons = markFavButtons;
  document.addEventListener('etolie:favs', function () {
    markFavButtons(document);
  });

  // ===== Dodanie do koszyka z kafelka (ETOLIE 02.08.2026) =====
  // Karta niesie `data-etolie-add`: JSON `rozmiar → id wariantu`, tylko DOSTĘPNE warianty
  // aktywnego koloru. Produkt bez opcji rozmiaru ma jeden klucz "". Ten sam obiekt jest
  // źródłem prawdy dla przekreślania rozmiarów, więc nie ma drugiej listy do rozjechania.
  function etolieCardVariants(card) {
    if (!card) return {};
    try {
      const parsed = JSON.parse(card.dataset.etolieAdd || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  // Wartość mapy to para [id wariantu, cena]. Te dwie funkcje są jedynym miejscem,
  // które o tym wie — reszta kodu pyta o id albo o cenę, nie o kształt danych.
  function etolieId(wpis) { return Array.isArray(wpis) ? wpis[0] : wpis; }
  function etolieCena(wpis) { return Array.isArray(wpis) ? wpis[1] : ''; }

  function etolieUstawCene(card, cena, porownanie) {
    const el = card && card.querySelector('[data-etolie-card-price]');
    if (!el || !cena) return;
    el.textContent = '';
    if (porownanie) {
      const stara = document.createElement('s');
      stara.textContent = porownanie;
      el.appendChild(stara);
    }
    el.appendChild(document.createTextNode(cena));
  }

  function etolieAtcLabel(card, text) {
    const label = card.querySelector('[data-etolie-atc-label]');
    if (label) label.textContent = text;
  }

  function etolieAtcReset(card) {
    if (!card) return;
    // Dopóki /cart/add.js leci, przycisk zostaje zablokowany — inaczej zmiana koloru
    // w trakcie żądania odblokowuje go i klientka dokłada drugą sztukę.
    const wTrakcie = card.__etolieAdding === true;
    card.classList.remove('is-picking');
    card.querySelectorAll('.etolie-card__size[role="button"]').forEach(function (size) {
      size.removeAttribute('role');
      size.removeAttribute('tabindex');
    });
    const btn = card.querySelector('[data-etolie-atc]');
    if (!btn) return;
    btn.classList.remove('is-picking', 'is-done');
    if (!wTrakcie) {
      btn.disabled = false;
      etolieAtcLabel(card, window.etolieT("Dodaj do koszyka"));
    }
  }

  function etolieAtcPick(card) {
    const dostepne = etolieCardVariants(card);
    card.classList.add('is-picking');
    card.querySelectorAll('.etolie-card__size[data-size-value]').forEach(function (size) {
      if (!(size.dataset.sizeValue in dostepne)) return;
      size.setAttribute('role', 'button');
      size.setAttribute('tabindex', '0');
    });
    const btn = card.querySelector('[data-etolie-atc]');
    if (btn) btn.classList.add('is-picking');
    etolieAtcLabel(card, window.etolieT("Wybierz rozmiar"));
  }

  // Odmowa Shopify (422) dotyczy JEDNEGO rozmiaru, nie całego kafelka. Wypadający
  // rozmiar znika z mapy i zostaje przekreślony, a karta wraca do stanu używalnego —
  // wcześniej `return` w tej gałęzi zostawiał zablokowany przycisk i kartę w trybie
  // wyboru, w którym kliknięcia są przechwytywane, więc kafelek stawał się martwy.
  function etolieOdmowaRozmiaru(card, klucz) {
    const warianty = etolieCardVariants(card);
    if (klucz !== undefined && klucz in warianty) {
      delete warianty[klucz];
      card.dataset.etolieAdd = JSON.stringify(warianty);
      card.querySelectorAll('.etolie-card__size[data-size-value]').forEach(function (size) {
        if (size.dataset.sizeValue === klucz) {
          size.classList.add('etolie-card__size--out');
          size.removeAttribute('role');
          size.removeAttribute('tabindex');
        }
      });
      initEtolieSizes(card);
    }
    return Object.keys(etolieCardVariants(card)).length;
  }

  function etolieAtcAdd(card, wpis, klucz) {
    const variantId = etolieId(wpis);
    const btn = card.querySelector('[data-etolie-atc]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    card.__etolieAdding = true;
    etolieAtcLabel(card, window.etolieT("Dodaję…"));
    const sekcjeKoszyka = [...document.querySelectorAll('cart-items-component')]
      .map(function (el) { return el.dataset && el.dataset.sectionId; })
      .filter(Boolean);
    const ladunek = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (sekcjeKoszyka.length) ladunek.sections = sekcjeKoszyka.join(',');
    let sekcjeZOdpowiedzi = null;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(ladunek),
    })
      .then(function (response) {
        if (!response.ok) {
          // Shopify odmawia (422) najczęściej z powodu braku stanu. Sklep ma dużo
          // towaru jednosztukowego, więc „Spróbuj ponownie" byłoby zaproszeniem
          // do pętli bez wyjścia — mówimy wprost, co się stało.
          return response.json().catch(function () { return null; }).then(function () {
            const blad = new Error('add');
            blad.brakStanu = response.status === 422;
            throw blad;
          });
        }
        card.classList.remove('is-picking');
        card.querySelectorAll('.etolie-card__size[role="button"]').forEach(function (size) {
          size.removeAttribute('role');
          size.removeAttribute('tabindex');
        });
        btn.classList.remove('is-picking');
        btn.classList.add('is-done');
        etolieAtcLabel(card, window.etolieT("Dodano ✓"));
        card.__etolieAdding = false;
        return response.json().catch(function () { return null; }).then(function (dane) {
          if (dane && dane.sections) sekcjeZOdpowiedzi = dane.sections;
          return fetch(window.Shopify.routes.root + 'cart.js');
        }).then(function (r) {
          if (!r.ok) throw new Error('refresh');
          return r.json();
        });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'etolie-card',
            data: {
              source: 'etolie-card',
              itemCount: cart.item_count,
              variantId: Number(variantId),
              sections: sekcjeZOdpowiedzi,
            },
          },
        }));
        setTimeout(function () { etolieAtcReset(card); }, 2200);
      })
      .catch(function (error) {
        card.__etolieAdding = false;
        if (error && error.brakStanu) {
          const zostalo = etolieOdmowaRozmiaru(card, klucz);
          btn.disabled = false;
          if (zostalo > 0) {
            // Zostały inne rozmiary — mówimy o czym, i karta dalej działa.
            etolieAtcLabel(card, window.etolieT("Nie ma więcej sztuk"));
            setTimeout(function () {
              etolieAtcLabel(card, card.classList.contains('is-picking') ? window.etolieT("Wybierz rozmiar") : window.etolieT("Dodaj do koszyka"));
            }, 2200);
          } else {
            etolieAtcReset(card);
            etolieAtcLabel(card, window.etolieT("Nie ma więcej sztuk"));
            btn.disabled = true;
          }
          return;
        }
        if (error && error.message === 'refresh') {
          // Sztuka JEST już w koszyku, tylko nie znamy jego stanu. Nie odblokowujemy
          // przycisku, żeby ponowny klik nie dołożył drugiej — tak samo jak na PDP.
          return;
        }
        btn.disabled = false;
        etolieAtcLabel(card, window.etolieT("Spróbuj ponownie"));
        setTimeout(function () { etolieAtcReset(card); }, 1800);
      });
  }

  function etolieAtcClick(card) {
    if (!card) return;
    if (card.classList.contains('is-picking')) {
      etolieAtcReset(card);
      return;
    }
    const warianty = etolieCardVariants(card);
    const klucze = Object.keys(warianty);
    if (!klucze.length) return;
    if (klucze.length === 1) etolieAtcAdd(card, warianty[klucze[0]], klucze[0]);
    else etolieAtcPick(card);
  }

  function etolieAtcPickSize(size) {
    const card = size.closest('.etolie-card');
    const wpis = etolieCardVariants(card)[size.dataset.sizeValue];
    if (!wpis) return;
    // Kafelek mówił „od X" — po wyborze rozmiaru pokazuje dokładnie tę cenę,
    // którą policzy koszyk.
    etolieUstawCene(card, etolieCena(wpis), '');
    etolieAtcAdd(card, wpis, size.dataset.sizeValue);
  }

  // Jeden stan karty aktualizuje jednocześnie kolor, oba linki i rozmiary per kolor.
  function etolieSetColor(card, sw, showMedia) {
    if (!card || !sw) return;
    card.querySelectorAll('.etolie-card__swatch').forEach(function (s) {
      s.classList.toggle('is-active', s === sw);
    });
    if (sw.dataset.variantUrl) {
      card.querySelectorAll('[data-etolie-card-link]').forEach(function (link) {
        link.setAttribute('href', sw.dataset.variantUrl);
      });
    }
    // 12.10.2026 (audyt SEO): link koloru domyślnego to adres główny bez ?variant=, więc wariant
    // aktywnego koloru dla szybkiego dodawania niesie karta (ten sam wariant co w adresie koloru).
    if (sw.dataset.favVariantId) card.dataset.etolieVariant = sw.dataset.favVariantId;
    const fav = card.querySelector('[data-etolie-fav]');
    if (fav) {
      fav.dataset.etolieFavVariant = sw.dataset.favVariantId || '';
      fav.dataset.etolieFavColor = sw.dataset.favColor || sw.dataset.color || '';
      fav.dataset.etolieFavDisplayColor = sw.dataset.color || '';
    }
    const colorLabel = card.querySelector('[data-etolie-card-color]');
    if (colorLabel) {
      const nextColor = sw.dataset.color || '';
      colorLabel.textContent = nextColor || '\u00a0';
      colorLabel.classList.toggle('etolie-card__color--empty', !nextColor);
      if (nextColor) colorLabel.removeAttribute('aria-hidden');
      else colorLabel.setAttribute('aria-hidden', 'true');
    }
    if (sw.hasAttribute('data-price')) {
      // Cena, mapa wariantów i przycisk opisują ZAWSZE ten sam wariant.
      etolieUstawCene(card, sw.dataset.price, sw.dataset.compare);
    }
    if (sw.hasAttribute('data-sizes')) {
      // Mapa wariantów tego koloru jest jedynym źródłem prawdy: zasila i listę rozmiarów,
      // i przekreślanie wyprzedanych, i dodanie do koszyka.
      const zmianaKoloru = card.dataset.etolieAdd !== sw.dataset.sizes;
      card.dataset.etolieAdd = sw.dataset.sizes;
      const dostepne = etolieCardVariants(card);
      const box = card.querySelector('[data-etolie-sizes] .etolie-card__sizes-vals');
      const wszystkie = (sw.dataset.sizesAll || '').split('|~|').filter(Boolean);
      if (box && wszystkie.length) {
        // Kafelki rozmiarów opisują kolor, który jest aktywny — przebudowujemy je,
        // zamiast tylko przekreślać rozmiary należące do innego koloru.
        box.textContent = '';
        wszystkie.forEach(function (wartosc) {
          const chip = document.createElement('span');
          const etykieta = wartosc.toLowerCase().indexOf('uniwersaln') >= 0 ? 'uniwersalny' : wartosc;
          chip.className = 'etolie-card__size' + (wartosc in dostepne ? '' : ' etolie-card__size--out');
          chip.dataset.size = etykieta;
          chip.dataset.sizeValue = wartosc;
          chip.textContent = etykieta;
          box.appendChild(chip);
        });
        const etykietaPola = card.querySelector('.etolie-card__sizes-label');
        if (etykietaPola) etykietaPola.textContent = wszystkie.length > 1 ? window.etolieT("Rozmiary") : window.etolieT("Rozmiar");
        initEtolieSizes(card);
      } else {
        card.querySelectorAll('.etolie-card__size[data-size-value]').forEach(function (size) {
          size.classList.toggle('etolie-card__size--out', !(size.dataset.sizeValue in dostepne));
        });
      }
      // Rozpoczęty wybór rozmiaru dotyczył poprzedniego koloru — po zmianie jest nieaktualny.
      if (zmianaKoloru) etolieAtcReset(card);
    }
    const media = card.querySelector('.etolie-card__media');
    if (showMedia !== false && media && media.__etolieShow) media.__etolieShow(sw.dataset.color);
  }

  document.addEventListener('click', function (e) {
    const favBtn = e.target.closest('[data-etolie-fav]');
    if (favBtn) {
      e.preventDefault();
      e.stopPropagation();
      const wasPressed = favBtn.getAttribute('aria-pressed') === 'true';
      window.etolieFavs.toggle(favItemFromButton(favBtn), { matchLegacy: wasPressed });
      return;
    }
    const swatchBtn = e.target.closest('.etolie-card__swatch[data-color]');
    if (swatchBtn) {
      e.preventDefault();
      if (!swatchBtn.classList.contains('etolie-card__swatch--out')) {
        etolieSetColor(swatchBtn.closest('.etolie-card'), swatchBtn, true);
        markFavButtons(document);
      }
      return;
    }
    // Rozmiar jest klikalny tylko wtedy, gdy karta czeka na wybór — poza tym trybem
    // klik w rozmiar ma nadal otwierać produkt przez link karty.
    const sizeBtn = e.target.closest('.etolie-card.is-picking .etolie-card__size');
    if (sizeBtn && !sizeBtn.classList.contains('etolie-card__size--out')) {
      e.preventDefault();
      e.stopPropagation();
      etolieAtcPickSize(sizeBtn);
      return;
    }
    const atcBtn = e.target.closest('[data-etolie-atc]');
    if (atcBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (!atcBtn.disabled) etolieAtcClick(atcBtn.closest('.etolie-card'));
    }
  });

  // Klawiatura: w trybie wyboru rozmiary są rolą przycisku, więc muszą reagować na Enter/Spację.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    const sizeBtn = e.target.closest && e.target.closest('.etolie-card.is-picking .etolie-card__size[role="button"]');
    if (!sizeBtn || sizeBtn.classList.contains('etolie-card__size--out')) return;
    e.preventDefault();
    etolieAtcPickSize(sizeBtn);
  });

  // Dostępne rozmiary są pierwsze; w każdej grupie zachowujemy kolejność:
  // litery XS..XXL, potem liczby rosnąco, uniwersalny na końcu.
  function initEtolieSizes(root) {
    var ORD = { xxs: 0, xs: 1, s: 2, m: 3, l: 4, xl: 5, xxl: 6, xxxl: 7 };
    function rank(v) {
      v = (v || '').trim().toLowerCase();
      if (v in ORD) return ORD[v];
      if (v.indexOf('uniwersal') >= 0) return 9999;
      var n = parseInt(v, 10);
      if (!isNaN(n)) return 100 + n;
      return 5000;
    }
    (root || document).querySelectorAll('[data-etolie-sizes] .etolie-card__sizes-vals').forEach(function (box) {
      var items = Array.prototype.slice.call(box.querySelectorAll('.etolie-card__size'));
      items.sort(function (a, b) {
        var aOut = a.classList.contains('etolie-card__size--out') ? 1 : 0;
        var bOut = b.classList.contains('etolie-card__size--out') ? 1 : 0;
        return (aOut - bOut) || (rank(a.dataset.size) - rank(b.dataset.size));
      });
      items.forEach(function (el) { box.appendChild(el); });
    });
  }

  function etolieSwatches(root) {
    (root || document).querySelectorAll('.etolie-card__swatch[data-color]').forEach(function (s) {
      if (s.dataset.sw) return;
      s.dataset.sw = '1';
      if (!s.title) s.title = s.getAttribute('data-color') || '';
      // Jeden resolver: exact eyedrop albo słownik nazwy. Zdjęcie produktu
      // nigdy nie jest próbką koloru; brak mapowania zostaje jawnie oznaczony.
      var resolved = window.etolieResolveSwatch
        ? window.etolieResolveSwatch(s.dataset.vid, s.dataset.sourceColor || s.dataset.color)
        : null;
      if (resolved) {
        s.style.background = resolved.background;
        s.style.backgroundPosition = 'center';
        s.style.backgroundRepeat = resolved.background.indexOf('radial-gradient') !== -1 ? 'repeat' : 'no-repeat';
        s.style.backgroundSize = resolved.background.indexOf('radial-gradient') !== -1 ? '6px 6px' : '';
        s.dataset.swatchSource = resolved.source;
      } else {
        s.dataset.swatchUnresolved = 'true';
      }
    });
  }

  // Katalog potrafi mieć setki kart. Pierwsza miniatura jest gotowa od razu,
  // a kolejne pobieramy dopiero przy świadomej interakcji. Zdjęcia nie zmieniają
  // się samoczynnie; klientka kontroluje galerię strzałką, swipe'em lub swatchem.
  const ETOLIE_CARD_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
  const ETOLIE_CARD_IMAGE_MAX_ATTEMPTS = 2;

  function hydrateEtolieCardImage(image) {
    if (!image || !image.dataset.etolieSrc || image.dataset.etolieLoading === '1' || image.dataset.etolieFailed === '1') return false;
    const attempts = Number(image.dataset.etolieAttempts || 0);
    if (attempts >= ETOLIE_CARD_IMAGE_MAX_ATTEMPTS) {
      image.dataset.etolieFailed = '1';
      return false;
    }

    const source = image.dataset.etolieSrc;
    const sourceSet = image.dataset.etolieSrcset || '';
    const attempt = attempts + 1;
    const hydrationId = (image.__etolieHydrationId || 0) + 1;
    image.__etolieHydrationId = hydrationId;
    image.dataset.etolieAttempts = String(attempt);
    image.dataset.etolieLoading = '1';

    const cleanup = () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };
    const onLoad = () => {
      if (image.__etolieHydrationId !== hydrationId || image.naturalWidth <= 1) return;
      cleanup();
      image.dataset.etolieLoaded = '1';
      delete image.dataset.etolieLoading;
      delete image.dataset.etolieAttempts;
      delete image.dataset.etolieFailed;
      delete image.dataset.etolieSrc;
      delete image.dataset.etolieSrcset;
    };
    const onError = () => {
      if (image.__etolieHydrationId !== hydrationId) return cleanup();
      cleanup();
      delete image.dataset.etolieLoading;
      if (attempt >= ETOLIE_CARD_IMAGE_MAX_ATTEMPTS) image.dataset.etolieFailed = '1';
      image.removeAttribute('srcset');
      image.src = ETOLIE_CARD_PLACEHOLDER;
    };

    // Listener nie jest `once`: ewentualny spóźniony load placeholdera 1×1
    // ma zostać zignorowany, a prawdziwy load tej próby nadal obsłużony.
    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);
    if (sourceSet) image.srcset = sourceSet;
    image.src = source;
    return true;
  }

  function hydrateEtolieCardMedia(media) {
    if (!media) return;
    media.querySelectorAll('img[data-etolie-src]').forEach(hydrateEtolieCardImage);
  }

  // Kafelki oznaczone `data-etolie-defer` (dziś: szyna rekomendacji na karcie
  // produktu) mają bezwładne także PIERWSZE zdjęcie. Leżą daleko pod zgięciem,
  // a na wolnym łączu przeglądarka pobiera lazy z zapasem liczonym w tysiącach
  // pikseli, więc ich zdjęcia zabierały pasmo zdjęciu głównemu produktu.
  // Źródło podstawiamy dopiero, gdy szyna zbliża się do viewportu.
  let etolieDeferredImageObserver = null;

  function etolieHydrateDeferredImage(image) {
    if (!image) return;
    delete image.dataset.etolieDefer;
    hydrateEtolieCardImage(image);
  }

  function initEtolieDeferredCardImages(root) {
    const images = [...(root || document).querySelectorAll('img[data-etolie-defer]')];
    if (!images.length) return;

    if (!('IntersectionObserver' in window)) {
      images.forEach(etolieHydrateDeferredImage);
      return;
    }

    if (!etolieDeferredImageObserver) {
      etolieDeferredImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          etolieHydrateDeferredImage(entry.target);
        });
      }, { rootMargin: '400px 0px' });
    }

    images.forEach(function (image) { etolieDeferredImageObserver.observe(image); });
  }

  // Stabilna galeria kart: wyłącznie ręczne strzałki, swipe i swatche, bez timera autoplay.
  function initEtolieCardGalleries(root) {
    const galleries = [...(root || document).querySelectorAll('[data-etolie-card-gallery-media]')].filter(
      (el) => el.querySelectorAll('img').length > 1 && !el.__etolieInit
    );
    galleries.forEach((el) => {
      el.__etolieInit = true;
      el.classList.add('is-js');
      const imgs = [...el.querySelectorAll('img')];
      let idx = 0;
      let requestedInitialIndex = 0;
      let activeColorMissingImage = false;
      const card0 = el.closest('.etolie-card');
      const belongsToHorizontalRail = !!el.closest('[data-etolie-card-rail]');
      const actSw0 = card0 && card0.querySelector('.etolie-card__swatch.is-active');
      if (actSw0) {
        const k0 = imgs.findIndex((im) => im.dataset.color === actSw0.dataset.color);
        if (k0 > 0) requestedInitialIndex = k0;
        else if (k0 < 0) activeColorMissingImage = true;
      }
      // Zdjęcie odroczone do viewportu ma jedno źródło decyzji — obserwator.
      if (!imgs[idx].dataset.etolieDefer) hydrateEtolieCardImage(imgs[idx]);
      imgs[idx].classList.add('is-shown');
      imgs[idx].style.zIndex = 1;
      imgs.forEach((image, imageIndex) => image.setAttribute('aria-hidden', imageIndex === idx ? 'false' : 'true'));

      // Kropki tylko przy wielu zdjęciach jednego koloru; przy kolorach rolę wskaźnika ma swatch.
      const hasSwatches = !!(card0 && card0.querySelector('.etolie-card__swatch[data-color]'));
      let updateDots = function () {};
      let updateProgress = function () {};
      if (!hasSwatches) {
        const dotsWrap = document.createElement('div');
        dotsWrap.className = 'etolie-card__dots';
        const dots = imgs.map(function (_, j) {
          const dot = document.createElement('span');
          dot.className = 'etolie-card__dot' + (j === idx ? ' is-on' : '');
          dotsWrap.appendChild(dot);
          return dot;
        });
        el.appendChild(dotsWrap);
        updateDots = () => dots.forEach((dot, j) => dot.classList.toggle('is-on', j === idx));
      }

      const settleLayers = () => {
        imgs.forEach((image, imageIndex) => {
          const current = imageIndex === idx;
          image.classList.toggle('is-shown', current);
          image.style.zIndex = current ? 1 : 0;
          image.setAttribute('aria-hidden', current ? 'false' : 'true');
        });
        updateDots();
        updateProgress();
      };

      const syncCardState = () => {
        const current = imgs[idx];
        if (!card0 || !current || !current.dataset.color) return;
        const currentSwatch = [...card0.querySelectorAll('.etolie-card__swatch[data-color]')].find(
          (swatch) => swatch.dataset.color === current.dataset.color
        );
        if (currentSwatch) {
          etolieSetColor(card0, currentSwatch, false);
          markFavButtons(document);
        }
      };

      const showIndex = (nextIndex) => {
        if (nextIndex < 0 || nextIndex >= imgs.length) return;
        const requestId = (el.__etolieImageRequest || 0) + 1;
        el.__etolieImageRequest = requestId;
        if (nextIndex === idx) {
          el.__etoliePendingIndex = null;
          if (el.__etolieLayerTimer) clearTimeout(el.__etolieLayerTimer);
          el.__etolieLayerTimer = null;
          settleLayers();
          syncCardState();
          return;
        }

        const next = imgs[nextIndex];
        if (next.dataset.etolieFailed === '1') {
          el.__etoliePendingIndex = null;
          if (el.__etolieLayerTimer) clearTimeout(el.__etolieLayerTimer);
          el.__etolieLayerTimer = null;
          settleLayers();
          syncCardState();
          return;
        }
        el.__etoliePendingIndex = nextIndex;
        hydrateEtolieCardImage(next);

        const reveal = () => {
          if (el.__etolieImageRequest !== requestId || next.naturalWidth <= 1) return;
          if (el.__etolieLayerTimer) clearTimeout(el.__etolieLayerTimer);
          el.__etolieLayerTimer = null;
          // Każdy crossfade zaczyna się od dokładnie jednej stabilnej warstwy.
          // Dzięki temu dwa szybkie przejścia nie zostawiają dwóch obrazów z z-index 2.
          settleLayers();
          idx = nextIndex;
          el.__etoliePendingIndex = null;
          syncCardState();
          updateDots();
          updateProgress();
          next.style.zIndex = 2;
          next.classList.add('is-shown');
          el.__etolieLayerTimer = setTimeout(() => {
            settleLayers();
            el.__etolieLayerTimer = null;
          }, 200);
        };

        const revealDecoded = () => {
          if (typeof next.decode !== 'function') return reveal();
          // decode() potrafi nigdy sie nie rozstrzygnac (zaobserwowane w Chromium
          // na zaladowanym obrazku karty) — wtedy zdjecie nie przelaczaloby sie
          // wcale. Dekodowanie to optymalizacja plynnosci, nie warunek pokazania,
          // wiec scigamy je z krotkim bezpiecznikiem; reveal odpala dokladnie raz.
          let odpalone = false;
          const raz = () => { if (odpalone) return; odpalone = true; reveal(); };
          next.decode().catch(function () {}).then(raz);
          setTimeout(raz, 250);
        };
        if (next.complete && next.naturalWidth > 1) revealDecoded();
        else {
          const cleanupRequestListeners = () => {
            next.removeEventListener('load', onRequestLoad);
            next.removeEventListener('error', onRequestError);
          };
          const onRequestLoad = () => {
            // Nie konsumujemy listenera na loadzie resetującego placeholdera 1×1.
            if (next.naturalWidth <= 1) return;
            cleanupRequestListeners();
            revealDecoded();
          };
          const onRequestError = () => {
            cleanupRequestListeners();
            if (el.__etolieImageRequest !== requestId) return;
            el.__etoliePendingIndex = null;
            if (el.__etolieLayerTimer) clearTimeout(el.__etolieLayerTimer);
            el.__etolieLayerTimer = null;
            settleLayers();
            syncCardState();
          };
          next.addEventListener('load', onRequestLoad);
          next.addEventListener('error', onRequestError);
        }
      };
      const fullySoldOutCard = !!(card0 && card0.classList.contains('etolie-card--sold-out'));
      const isNavigableImage = (candidate) => {
        if (!candidate || candidate.dataset.etolieFailed === '1') return false;
        const color = candidate.dataset.color;
        if (!color || !card0 || fullySoldOutCard) return true;
        const swatch = [...card0.querySelectorAll('.etolie-card__swatch[data-color]')].find(
          (item) => item.dataset.color === color
        );
        return !swatch || !swatch.classList.contains('etolie-card__swatch--out');
      };
      const nextNavigableIndex = (direction, fromIndex) => {
        const origin = Number.isInteger(fromIndex) ? fromIndex : idx;
        for (let candidateIndex = origin + direction;
          candidateIndex >= 0 && candidateIndex < imgs.length;
          candidateIndex += direction) {
          const candidate = imgs[candidateIndex];
          if (isNavigableImage(candidate)) return candidateIndex;
        }
        return origin;
      };
      const navigableImageCount = imgs.filter(isNavigableImage).length;
      const navigableIndexes = imgs.reduce((indexes, image, imageIndex) => {
        if (isNavigableImage(image)) indexes.push(imageIndex);
        return indexes;
      }, []);
      const galleryColors = new Set(imgs.map((image) => image.dataset.color || '').filter(Boolean));
      const isExactGallery = !hasSwatches || galleryColors.size <= 1;
      if (navigableImageCount > 1 && isExactGallery) {
        const progress = document.createElement('span');
        const progressThumb = document.createElement('span');
        progress.className = 'etolie-card__progress';
        progress.setAttribute('role', 'progressbar');
        progress.setAttribute('aria-label', window.etolieT("Pozycja zdjęcia produktu"));
        progress.setAttribute('aria-valuemin', '1');
        progress.setAttribute('aria-valuemax', String(navigableIndexes.length));
        progress.style.setProperty('--etolie-card-progress-count', String(navigableIndexes.length));
        progressThumb.className = 'etolie-card__progress-thumb';
        progress.appendChild(progressThumb);
        el.appendChild(progress);
        updateProgress = () => {
          const position = Math.max(0, navigableIndexes.indexOf(idx));
          progress.style.setProperty('--etolie-card-progress-index', String(position));
          progress.setAttribute('aria-valuenow', String(position + 1));
          progress.setAttribute('aria-valuetext', window.etolieT('Zdjęcie {position} z {total}', {position: position + 1, total: navigableIndexes.length}));
        };
        updateProgress();
      }
      const manualGo = (direction) => {
        const pending = el.__etoliePendingIndex;
        const origin = pending !== null && pending !== undefined ? pending : idx;
        showIndex(nextNavigableIndex(direction, origin));
      };
      const CHEV = {
        prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>',
        next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>'
      };
      // Kontrolki tworzymy tylko wtedy, gdy klientka może faktycznie przejść do
      // drugiego obrazu. Pełny OOS pozwala oglądać wszystkie kolory, ale częściowo
      // wyprzedane swatche nie tworzą martwych strzałek.
      const cardLabel = card0 && card0.querySelector('[data-etolie-card-link]')
        ? card0.querySelector('[data-etolie-card-link]').getAttribute('aria-label') || ''
        : '';
      if (navigableImageCount > 1) ['prev', 'next'].forEach(function (direction) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'etolie-card__navarrow etolie-card__navarrow--' + direction;
        const actionLabel = direction === 'prev' ? window.etolieT("Poprzednie zdjęcie") : window.etolieT("Następne zdjęcie");
        button.setAttribute('aria-label', cardLabel ? actionLabel + ': ' + cardLabel : actionLabel);
        button.innerHTML = CHEV[direction];
        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          manualGo(direction === 'prev' ? -1 : 1);
        });
        el.appendChild(button);
      });

      // tap = wejście na produkt, poziomy swipe = ręczna zmiana zdjęcia
      let sx = 0, sy = 0, st = 0, didMove = false;
      el.addEventListener('pointerenter', function () {
        hydrateEtolieCardImage(imgs[nextNavigableIndex(1)]);
      }, { once: true, passive: true });
      el.addEventListener('touchstart', function (e) {
        if (belongsToHorizontalRail) return;
        const touch = e.changedTouches[0];
        sx = touch.clientX; sy = touch.clientY; st = Date.now(); didMove = false;
      }, { passive: true });
      el.addEventListener('touchmove', function (e) {
        if (belongsToHorizontalRail) return;
        const touch = e.changedTouches[0];
        const dx = touch.clientX - sx, dy = touch.clientY - sy;
        if (Math.abs(dx) >= Math.max(32, el.clientWidth * 0.12) && Math.abs(dx) > Math.abs(dy) * 1.25) {
          didMove = true;
          const pending = el.__etoliePendingIndex;
          const origin = pending !== null && pending !== undefined ? pending : idx;
          hydrateEtolieCardImage(imgs[nextNavigableIndex(dx < 0 ? 1 : -1, origin)]);
          e.preventDefault();
        }
      }, { passive: false });
      el.addEventListener('touchend', function (e) {
        if (belongsToHorizontalRail) return;
        const touch = e.changedTouches[0];
        const dx = touch.clientX - sx, dy = touch.clientY - sy;
        if ((didMove || Math.abs(dx) >= Math.max(32, el.clientWidth * 0.12)) && Math.abs(dx) > Math.abs(dy) * 1.25 && Date.now() - st < 1000) {
          el.__swiped = true;
          setTimeout(function () { el.__swiped = false; }, 350);
          e.preventDefault();
          manualGo(dx < 0 ? 1 : -1);
        }
      }, { passive: false });
      el.addEventListener('click', function (e) {
        if (belongsToHorizontalRail) return;
        if (el.__swiped) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      const mediaLink = el.querySelector('.etolie-card__media-link');
      if (mediaLink) {
        mediaLink.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            manualGo(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            manualGo(1);
          } else if (event.key === 'Home') {
            event.preventDefault();
            showIndex(navigableIndexes && navigableIndexes.length ? navigableIndexes[0] : 0);
          } else if (event.key === 'End') {
            event.preventDefault();
            showIndex(navigableIndexes && navigableIndexes.length ? navigableIndexes[navigableIndexes.length - 1] : imgs.length - 1);
          }
        });
      }
      el.__etolieShow = (color) => {
        const colorIndex = imgs.findIndex((img) => img.dataset.color === color);
        if (colorIndex < 0) return;
        showIndex(colorIndex);
      };
      if (requestedInitialIndex > 0) showIndex(requestedInitialIndex);
      else if (activeColorMissingImage) {
        // Gdy aktywny swatch nie ma żadnego obrazu, stan karty dopasowujemy
        // do faktycznie widocznego fallbacku zamiast mieszać zdjęcie i link innego koloru.
        settleLayers();
        syncCardState();
      }
    });
  }

  window.etolieInitCards = function (root) {
    const scope = root || document;
    // Zawsze licz cały dokument, aby jeden historyczny wpis po handle nie
    // zaznaczył osobno każdego kafelka koloru inicjalizowanego w innej sekcji.
    markFavButtons(document);
    initEtolieSizes(scope);
    etolieSwatches(scope);
    initEtolieCardGalleries(scope);
    initEtolieDeferredCardImages(scope);
    scope.querySelectorAll('.etolie-card__swatch.is-active').forEach(function (swatch) {
      etolieSetColor(swatch.closest('.etolie-card'), swatch, false);
    });
  };
  window.etolieDestroyCards = function (root) {
    if (etolieDeferredImageObserver) {
      (root || document).querySelectorAll('img[data-etolie-defer]').forEach(function (image) {
        etolieDeferredImageObserver.unobserve(image);
      });
    }
    (root || document).querySelectorAll('[data-etolie-card-gallery-media]').forEach(function (el) {
      if (el.__etolieLayerTimer) window.clearTimeout(el.__etolieLayerTimer);
      el.__etolieLayerTimer = null;
      el.__etolieImageRequest = (el.__etolieImageRequest || 0) + 1;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.etolieInitCards(); });
  } else {
    window.etolieInitCards();
  }
}
